__webpack_require__.p = "https://pub-8671961b6a3348d0beed467d1f98634d.r2.dev/lomavis_react_frontend/react_app/";